import { useTranslation } from 'react-i18next';
import { SUPPORTED_LOCALES, setLocale, type Locale } from '@/i18n';
import { cn } from '@/lib/utils';

/**
 * EN / ES. The product is bilingual by requirement, so the switch exists from the first screen rather
 * than being retrofitted once a hundred strings are already inline.
 */
export function LocaleToggle() {
  const { i18n } = useTranslation();
  const current = i18n.resolvedLanguage;

  return (
    <div className="flex h-touch items-center rounded-md border border-hairline p-1">
      {SUPPORTED_LOCALES.map((locale: Locale) => (
        <button
          key={locale}
          type="button"
          onClick={() => setLocale(locale)}
          aria-pressed={current === locale}
          className={cn(
            'rounded-sm px-2 py-1 text-sm font-medium uppercase',
            current === locale
              ? 'bg-accent-base text-on-accent'
              : 'text-ink-muted hover:text-ink-secondary',
          )}
        >
          {locale}
        </button>
      ))}
    </div>
  );
}
